import React, { Component, Fragment } from 'react';
import { Collapse, Nav, NavItem, NavLink } from 'reactstrap';
import classnames from 'classnames';
import { Links } from './Links';

class LinksCategory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      collapseOpen: false,
      ...this.getCollapseStates(props.views)
    };
  };

  // this creates the intial state of this component based on the collapse routes
  // that it gets through this.props.routes
  getCollapseStates = routes => {
    let initialState = {};
    routes.map((prop, key) => {
      if (prop.collapse) {
        initialState = {
          [prop.state]: this.getCollapseInitialState(prop.views),
          ...this.getCollapseStates(prop.views),
          ...initialState
        };
      }
      return null;
    });
    return initialState;
  };

  // this verifies if any of the collapses should be default opened on a rerender of this component
  // for example, on the refresh of the page,
  // while on the src/views/forms/RegularForms.js - route /admin/regular-forms
  getCollapseInitialState(routes) {
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].collapse && this.getCollapseInitialState(routes[i].views)) {
        return true;
      } else if (window.location.href.indexOf(routes[i].path) !== -1) {
        return true;
      }
    }
    return false;
  };

  render() {
    return (
      <NavItem key={this.props.index}>
        <NavLink
          href="#pablo"
          id={ `nav-category-${this.props.index}` }
          data-toggle="collapse"
          aria-expanded={this.props.expanded}
          className={classnames({
            active: this.props.expanded
          })}
          onClick={ this.props.onClick }
        >
          {
            this.props.icon ? (
              <Fragment>
                <i className={ this.props.icon } />
                <span className="nav-link-text">{ this.props.name }</span>
              </Fragment>
            ) : this.props.miniName ? (
              <Fragment>
                <span className="sidenav-mini-icon"> { this.props.miniName } </span>
                <span className="sidenav-normal"> { this.props.name } </span>
              </Fragment>
            ) : null
          }
        </NavLink>
        <Collapse isOpen={this.props.expanded}>
          <Nav className="nav-sm flex-column">
            {
              this.props.views.map(
                (view, key) => {
                  if (view.collapse) {
                    return <LinksCategory
                      {...view}
                      location={ this.props.location }
                      key={ key }
                      index={ key }
                      expanded={ this.state[view.state] }
                      onClick={
                        e => {
                          e.preventDefault();
                          let st = {};
                          st[view['state']] = !this.state[view.state];
                          this.setState(st);
                        }
                      }
                    />
                  } else {
                    return (<Links {...view} key={key} location={ this.props.location } />);
                  }
              }
            )
            }
          </Nav>
        </Collapse>
      </NavItem>
    )
  }
}

LinksCategory.defaultProps = {
  views: [],
  index: 0,
  onClick: event => event.preventDefault()
};

export { LinksCategory };
